import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as informativePageActions from './informative-page.actions';
import { InformativePage } from 'src/app/models/informative-page';

export interface InformativePageState extends EntityState<InformativePage> {
  loadingInformativePages: boolean;
  informativePagesLoaded: boolean;
  selectedInformativePage: InformativePage;
}

export const informativePageAdapter: EntityAdapter<any> = createEntityAdapter<InformativePage>({});

export const initialInformativePageState: InformativePageState = informativePageAdapter.getInitialState({
  loadingInformativePages: false,
  informativePagesLoaded: false,
  selectedInformativePage: null,
});

export const reducer = createReducer(
  initialInformativePageState,
  on(informativePageActions.getInformativePages, (state) => {
    return {
      ...state,
      loadingInformativePages: true,
      informativePagesLoaded: false,
    };
  }),
  on(informativePageActions.getInformativePagesSuccess, (state, { informativePages }) => {
    return informativePageAdapter.setAll(informativePages, {
      ...state,
      loadingInformativePages: false,
      informativePagesLoaded: true,
    });
  }),
  on(informativePageActions.getInformativePagesError, (state) => {
    return {
      ...state,
      loadingInformativePages: false,
      informativePagesLoaded: false,
    };
  }),
  on(informativePageActions.setSelectedInformativePage, (state, { selectedInformativePage }) => {
    return {
      ...state,
      selectedInformativePage,
    };
  }),
  on(informativePageActions.createInformativePageSuccess, (state, { newInformativePage }) => {
    return informativePageAdapter.addOne(newInformativePage, {
      ...state,
      selectedInformativePage: null,
    });
  }),
  on(informativePageActions.updateInformativePageSuccess, (state, { updatedInformativePage }) => {
    return informativePageAdapter.updateOne(
      { id: updatedInformativePage?.id, changes: updatedInformativePage },
      {
        ...state,
        selectedInformativePage: null,
      }
    );
  }),
  on(informativePageActions.deleteInformativePageSuccess, (state, { deletedInformativePage }) => {
    return informativePageAdapter.removeOne(deletedInformativePage?.id, {
      ...state,
    });
  })
);

export function informativePageReducer(state: InformativePageState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = informativePageAdapter.getSelectors();
